import * as React from 'react';

const AlignMiddle = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.4 2H4.6V9.38462H1V10.6154H4.6V18H9.4V10.6154H10.6V14.9231H15.4V10.6154H19V9.38462H15.4V5.07692H10.6V9.38462H9.4V2Z" fill="currentColor"/>
  </svg>
);

export default AlignMiddle;
